<template>
  <el-table-column
    prop="position"
    sortable
    label="Beosztás"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.position }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'position',
  };
</script>
